"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonPay = void 0;
const Network_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/Network");
const api_1 = require("../../../lib/api");
const types_1 = require("../types");
const types_2 = require("./types");
class MoonPay {
    constructor(config) {
        const { apiKey, apiBaseUrl, widgetBaseUrl } = config;
        this.apiKey = apiKey;
        this.widgetBaseUrl = widgetBaseUrl;
        this.moonPayAPI = new api_1.BaseAPI(apiBaseUrl);
    }
    getPurchaseStatus(status) {
        return {
            [types_2.MoonPayTransactionStatus.WAITING_PAYMENT]: types_1.PurchaseStatus.PENDING,
            [types_2.MoonPayTransactionStatus.PENDING]: types_1.PurchaseStatus.PENDING,
            [types_2.MoonPayTransactionStatus.WAITING_AUTHORIZATION]: types_1.PurchaseStatus.PENDING,
            [types_2.MoonPayTransactionStatus.FAILED]: types_1.PurchaseStatus.FAILED,
            [types_2.MoonPayTransactionStatus.COMPLETED]: types_1.PurchaseStatus.COMPLETE
        }[status];
    }
    /**
     * Given the transaction id, returns the MoonPay Transaction.
     *
     * @param transactionId - MoonPay Transaction ID.
     */
    getTransaction(transactionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.moonPayAPI.request('GET', `/v1/transactions/${transactionId}`, { apiKey: this.apiKey });
        });
    }
    /**
     * Given the transaction, returns a Promise of an object with the relevant information of the purchase.
     *
     * @param transaction - MoonPay Transaction.
     */
    createPurchase(transaction, network) {
        const { id, quoteCurrencyAmount, createdAt, status, walletAddress, cryptoTransactionId, paymentMethod } = transaction;
        return {
            id,
            amount: quoteCurrencyAmount,
            network,
            timestamp: +new Date(createdAt),
            status: this.getPurchaseStatus(status),
            paymentMethod,
            address: walletAddress,
            gateway: Network_1.NetworkGatewayType.MOON_PAY,
            txHash: cryptoTransactionId
        };
    }
    getWidgetUrl(network) {
        const redirectURL = `${window.location.origin}?network=${network}&gateway=${Network_1.NetworkGatewayType.MOON_PAY}`;
        return `${this.widgetBaseUrl}?apiKey=${this.apiKey}&currencyCode=MANA&redirectURL=${encodeURIComponent(redirectURL)}`;
    }
    getTransactionReceiptUrl(transactionId) {
        return `${this.widgetBaseUrl}/transaction_receipt?transactionId=${transactionId}`;
    }
}
exports.MoonPay = MoonPay;
//# sourceMappingURL=MoonPay.js.map